import type { FaireProductEntity } from "../../entity_types/product";

export const p_5hwfy32but: FaireProductEntity = {
  token: "p_5hwfy32but",
  type: "product",
  name: "Rhinoceros Brass Crafts Decoration Desktop Ornaments",
  brandToken: "b_nex9pcmkzj",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/31cb990616bf1776ba06dc38a1f8b95d75ecb5a3a9ffd02ecc972ad80f54b251.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/213063a2a1252d7869797d4943366d2008ecfce5e243c1b96341212a93dae2f1.jpeg",
    "https://cdn.faire.com/fastly/c20cb10def69f07e4951bb88465168607c0899fe3f1a7bd90e61cf75738da7fa.jpeg",
    "https://cdn.faire.com/fastly/5138f46c1ffe36d683fe9cb02fef2e73d659937d94bcc9017b7ebde7fd3b110a.jpeg",
  ],
  priceDollars: 9.41,
  description: "Type: Ornaments\n\nMaterial: Brass\n\nSize: 54mm*26mm\n\n\n",
  tags: [],
  msrpDollars: 18.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.880Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
